app.mediator.registerModule(MODULE_NAME__VIDEO_LIGHTBOX, function(app) {
    var helpers = app.helpers.funcs;
    return {

        //==========================================================xdiv2====
        // Module attributes
        //===================================================================

        // settings
        maxTimeToWaitForVideoToStop: 3000,

        // Video data
        videoUrl: null,
        videoType: null,
        videoId: null,
        videoIdx: null,

        // The video player
        agnosticVideoPlayer: null,

        // State data
        initialHeight: null,
        initialPadding: null,
        screenWasResizedDuringVideoPlayback: false,

        // DOM elements (jquery versions)
        $rootElem: null,

	    //==========================================================xdiv2====
	    // Start and stop
	    //===================================================================

        onLoaded: function (data) {
            var scope = this;
            if (data.hasJustLoaded([RESOURCE_NAME__DOM, RESOURCE_NAME__YOUTUBE])) {
                scope.init();
            }
        },

        init: function () {

            var scope = this;

            // Get elems
            scope.$rootElem = $('.mod-video-lightbox');
            if (!scope.$rootElem.length) return;
            this.addDomListeners();
            this.addMediatorListeners();

            // Workup tmp vars
            var videoUrl = this.$rootElem.find('.video-link').attr('href');
            var videoData = scope.discernVideoTypeAndId(videoUrl);
            var videoIdx = JdaVideoTools.embedHelper.generateVideoIdx(scope.videoId);
            var embedHtml = scope.getEmbedCode(videoData.type, videoData.id, videoIdx);

            // Propogate tmp vars to module object
            scope.videoIdx = videoIdx;
	        scope.videoUrl = videoUrl;
	        scope.videoType = videoData.type;
	        scope.videoId = videoData.id;

            // Create HTML elements, and set internal references to these
            scope.$rootElem.find('.video-lightbox-video-wrap').append(embedHtml);

            // Create agnostic video player
	        scope.agnosticVideoPlayer = new JdaVideoTools.SourceAgnosticPlayer({
	            videoData: {
	                $iframeElem: scope.$rootElem.find('iframe'),
	                videoType: scope.videoType
	            },
	            eventData: {
	                onPlay: function() {
                        scope.onMediaPlaying();
                        scope.setIframeHeightAndOffset();
                        setTimeout(function () {
                            scope.setIframeHeightAndOffset();
                        }, 200);
	                },
	                onPause: function (pauseEventData) {
	                    scope.onMediaPaused(pauseEventData);
	                },
	                onBuffering: function(duringPlayback) {
	                    scope.onMediaBuffering(duringPlayback);
	                }
	            }
	        });

            // Scale the height of the video player
            scope.setIframeHeightAndOffset();
        },

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__HEADINGS_AREA__VIDEO_PLAY_BUTTON_ACTIVATED, function () {
                scope.playVideo();
                scope.setIframeHeightAndOffset();
            });
        },

        addDomListeners: function () {
            var scope = this;
            $(document).mousemove(function () {
                if (scope.$rootElem.hasClass('playing')) {
                    scope.showCloseBtnForPeriod();
                }
            });
            $(document).keyup(function (e) {
                if (e.keyCode == 27) { // esc
                    scope.pauseVideo();
                    scope.closeOverlay();
                }
            });
            scope.$rootElem.find('.video-lightbox-video-mask').click(function () {
                scope.pauseVideo();
                scope.closeOverlay();
            });
            $('.video-lightbox-video-close-btn').click(function (e) {
                scope.pauseVideo();
                scope.closeOverlay();
            });
            this.$rootElem.on('focus', '.video-lightbox-video-close-btn', function (e) {
                console.log('focus');
                scope.showCloseBtn();
            });
            this.$rootElem.on('blur', '.video-lightbox-video-close-btn', function (e) {
                console.log('blur');
                scope.hideCloseBtn();
            });
            app.globalEventRegistry.addListener('resize', function () {
                var playbackState = scope.agnosticVideoPlayer.getState();
                if (playbackState == 'paused') {
                }
                scope.setIframeHeightAndOffset();
                if (playbackState == 'playing') {
                    scope.screenWasResizedDuringVideoPlayback = true;
                }
            });
        },
		
		//==========================================================xdiv2====
		// Module methods
		//===================================================================

	    //---------------------------------------------------xdiv3----
	    // get
	    //------------------------------------------------------------

		getHeightRatio: function() {
		    if (typeof this.agnosticVideoPlayer.getHeightRatio == 'function') {
		        return this.agnosticVideoPlayer.getHeightRatio();
		    }
		    return 1;
		},

        getRelativeHeight: function () {
		    var isMobile = helpers.isMobile();
            var orientation = helpers.getOrientation();
			var heightRatio = this.getHeightRatio();
            var videoWidth = this.$rootElem.find('iframe').width();
            var videoHeight = videoWidth * heightRatio;
            return videoHeight;
		},

		discernVideoTypeAndId: function(videoUrl) {
			return JdaVideoTools.embedHelper.discernTypeAndId(videoUrl);
		},

		getEmbedCode: function(videoType, videoId, videoIdx) {
			return JdaVideoTools.embedHelper.getEmbedCode(videoType, videoId, videoIdx);
		},

		hasVideo: function() {
			return this.videoUrl && this.videoType && this.videoId;
		},

	    //---------------------------------------------------xdiv3----
	    // set
	    //------------------------------------------------------------

        setIframeHeightAndOffset: function () {
            var scope = this;
            var windowHeight = $(window).height();
            var iframeHeight = scope.getRelativeHeight();
            var topOffset = (windowHeight - iframeHeight) / 2;
            var closeButtonSpaceAllocation = 60;
            var windowWidth = $(window).width();
            scope.$rootElem.find('iframe').css({
                height: Math.min(windowHeight - closeButtonSpaceAllocation * 2, iframeHeight)
            });
		},

	    //---------------------------------------------------xdiv3----
	    // video control
	    //------------------------------------------------------------

        // --------------- Commands ---------------

		playVideo: function() {

			var scope = this;
			var hasVideo = this.hasVideo();
			if (!hasVideo) throw 'Trying to play video when there is no video.';

            scope.$rootElem.addClass('playing');
            scope.$rootElem.find('.video-lightbox-video-wrap').attr('aria-hidden', 'false');
            scope.$rootElem.find('.video-lightbox-video-wrap').removeClass('visibility-hidden');
            scope.$rootElem.addClass('playing');
            scope.agnosticVideoPlayer.play();
            scope.showCloseBtnForPeriod();

            app.mediator.notify(EVENT_NAME__VIDEO_LIGHTBOX__PLAYING);
		},

		pauseVideo: function() {
            this.agnosticVideoPlayer.pause();
            app.mediator.notify(EVENT_NAME__VIDEO_LIGHTBOX__PAUSED);
		},

        closeOverlay: function () {

		    var scope = this;

            scope.$rootElem.removeClass('playing');
            scope.hideCloseBtn();
            scope.$rootElem.find('.video-lightbox-video-wrap').attr('aria-hidden', 'true').addClass('visibility-hidden');
            
            if (scope.screenWasResizedDuringVideoPlayback) {
                scope.screenWasResizedDuringVideoPlayback = false;
            }

            app.mediator.notify(EVENT_NAME__VIDEO_LIGHTBOX__CLOSED);
		},

        // --------------- Listener responses ---------------

		onMediaPlaying: function() {
            $('.video-lightbox-video-close-btn').focus();
		},

		onMediaPaused: function (pauseEventData) {
            if (pauseEventData.ended) {
                this.closeOverlay();
            }
		},

		onMediaBuffering: function(duringPlayback) {
            // No actions yet
		},

	    //---------------------------------------------------xdiv3----
	    // video close btn
	    //------------------------------------------------------------
        
		showCloseBtn: function() {
            this.$rootElem.find('.video-lightbox-video-close-btn').addClass('video-lightbox-video-close-btn-shown');
		},

		showCloseBtnForPeriod: function(period) {
		    var scope = this;
		    period = typeof period !== 'undefined' ? period : 3000;
		    clearTimeout(scope.hideCloseBtnTimeout);
		    scope.showCloseBtn();
		    if (!period) return;
            scope.hideCloseBtnTimeout = setTimeout(function () {
                scope.hideCloseBtn();
            }, period);
		},

		hideCloseBtn: function() {
            this.$rootElem.find('.video-lightbox-video-close-btn').removeClass('video-lightbox-video-close-btn-shown');
		}

	};
});
